import { ProfilePostsProps } from '$core/Profile/ProfilePosts/ProfilePosts.interface';
import { Placeholder } from '$uikit';
import { Loader, Post } from '$shared/components';
import React from 'react';
import { useTranslator } from '$hooks';
import './ProfilePosts.sass';

const ProfilePostsComponent = ({ isUserBanned, posts, isLoading }: ProfilePostsProps) => {
  const t = useTranslator();

  if (isLoading) {
    return <Loader isWrapped />;
  }

  if (isUserBanned) {
    return null;
  }

  if (posts.length === 0) {
    return <Placeholder>{t('profile_posts_empty')}</Placeholder>;
  }

  return (
    <div className="Profile__posts">
      {posts.map((post) => (
        <Post key={post} postId={post} />
      ))}
    </div>
  );
};

export const ProfilePosts = React.memo(ProfilePostsComponent);
